import React, { useState } from "react";
import PricingCart from "./PricingCart";
import { API } from "../../api";
import LinkComponent3 from "../general/LinkComponent3";

const PricingComponent = ({
  data,
  authorized,
  activeSubsription,
  hide = false,
  skipModel = false,
  subscriptionType = "qbank" // you can use subscriptionType to customize display elements if needed
}) => {
  // Calculate discounted amounts dynamically based on actual subscription prices
  const discounted = data?.map((item) => ({
    id: item.id,
    amount: Math.round(item.price * 2), // 50% off means original price was 2x
  })) || [];
  return (
    <div className="PricingComponent ">
      <div className={`${!hide && `container`} w-full mx-auto`}>
        {hide ? (
          <div className="profile-header  py-4   interFont flex items-center w-full justify-between  ">
            <h2 className=" text-2xl interFont capitalize font-bold ">
              All Subscriptions
            </h2>
            <LinkComponent3
              to={"/user/dashboard/subscription"}
              text={"My Subscription"}
            />
          </div>
        ) : (
          <div className="lg:px-0 lg:py-0  mb-6 lg:mb-10 mt-6">
            <h1 className="text-themeSecondry-0 text-3xl sm:text-4xl lg:text-5xl capitalize   text-center">
              Subscription plans
            </h1>
            <h2 className="flex justify-center interfont text-[25px] py-1 px-3 text-black text-center">Unlock 3,500+ High-Yield Questions</h2>
            <p className="flex justify-center interfont text-[16px] py-1 px-3 text-black text-center">
              Choose the best suitable plan for your AMC CAT practice{" "}
            </p>
          </div>
        )}
        {/* {!hide && (
          <div className="lg:px-0 lg:py-0  mb-6 lg:mb-6">
            <h1 className="text-themeSecondry-0 text-3xl sm:text-4xl lg:text-5xl capitalize   text-center">
              Subscription plans
            </h1>
            <p className="flex justify-center interfont text-[16px] py-3 px-3 text-black text-center">
              Choose the best suitable plan for your AMC CAT practice{" "}
            </p>
          </div>
        )} */}
        <div
          className={` grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${
            hide ? `w-full` : `w-fit`
          }     mx-auto gap-20 md:gap-8  pt-4 `}
        >
          {data?.map((item, index) => (
            <PricingCart
              recommended={index === 1 ? true : false}
              authorized={authorized}
              key={index}
              plan={item?.name}
              duration={item?.duration}
              durationMode={item?.durationMode}
              price={item?.price}
              id={item?.id}
              item={item}
              activeSubsription={activeSubsription}
              discounted={discounted?.find((data) => data?.id === item?.id)}
              skipModel={skipModel}
              subscriptionType={subscriptionType}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingComponent;
